import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";

import "./styles.scss";

export const PhoneInput = ({
  className,
  disabled,
  error,
  name,
  onChange,
  placeholder,
  value,
  ...props
}) => {
  const numberFormat = (val) => {
    let mainVal;
    let firstNumber = val.substring(0, 3);
    let middleNumber = val.substring(3, 6);
    let lastNumber = val.substring(6, 10);

    if (firstNumber.length) {
      mainVal = `(${firstNumber})`;
    }
    if (firstNumber.length && middleNumber.length) {
      mainVal = `(${firstNumber}) ${middleNumber}`;
    }
    if (firstNumber.length && middleNumber.length && lastNumber.length) {
      mainVal = `(${firstNumber}) ${middleNumber}-${lastNumber}`;
    }

    return mainVal;
  };

  return (
    <NumberFormat
      className={createClassNameString([
        "apti-CL",
        "apti-PhoneInput",
        "apti-Input",
        className,
        error && "error",
      ])}
      disabled={disabled}
      elementtype="input"
      format={numberFormat}
      name={name}
      onValueChange={onChange}
      placeholder={placeholder}
      type="text"
      value={value}
      {...props}
    />
  );
};

PhoneInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

PhoneInput.defaultProps = {
  className: undefined,
  disabled: false,
  name: "",
  onChange: () => {},
  placeholder: undefined,
  value: undefined,
};
